<template>
  <center
    v-if="isBC && URL"
    style="padding-left: 50px;padding-right:50px; padding-top:10px;"
    :style="{ 'margin-top': isMenu ? '15px' : '0'}"
  >
    <v-btn
      block
      outlined
      :color="isMain ? Color : 'white'"
      style="height: 50px;"
      @click="handleGoBack"
    >
      {{backTitle}}
    </v-btn>
  </center>
</template>

<script>
  import {
    mapState
  } from 'vuex'
  import utils from '@/services/utils'
  import api from '@/services/api'
  export default {
    props: {
      isMain: {
        type: Boolean,
        required: false,
        default: false
      },
      isMenu: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data: () => ({
      // domain: null,
      URL: null,
      backTitle: ''
    }),
    computed: {
      ...mapState('app',['locale']),
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      Color () {
        return this.$store.state.app.Color
      },
      locale () {
        return this.$store.state.app.locale
      },
      isBC () {
        const domain = utils.getDomain()
        // pedido por WENDY
        if (['amaremarbellabelvue',
          'amaremarbellafoodanddrinks',
          'amaremarbellaverite',
          'amaremarbellavinos',
          'amaremarbellalounge',
          
          'marazulbar','marazulrestaurante', 'clumbabar','clumbarestaurante', 'sonmollattik','sonmollbarlobby','sonmollrestaurante',
          'sentradorplayabarhall','sentradorplayarestaurante','serranopalacepoolbar','serranopalacebarhall','serranopalacerestaurante','sonmollaurabeaty','sentradorplayaspaoasis','marazulsesones'
        ].indexOf(domain) >= 0) return true
        else return this.$route.query.bc && this.$route.query.bc !== undefined ? this.$route.query.bc : null
      }
    },
    watch: {
      locale (v) {
        this.backTitle = this.$t('common.back', v)
      }
    },
    mounted () {
      this.backTitle = this.$t('common.back', this.locale)
      if (this.isBC) {
        api.getItem('enterprises/custom-URL-back', false, this.enterpriseID).then(response => {
          this.URL = response.CustomURLBack ? response.CustomURLBack.replace(' ', '') : null
        })
      }
    },
    methods: {
      handleGoBack () {
        // let url = `${window.location.protocol}//${this.domain}.${process.env.VUE_APP_API_URL}`
        // if (this.locale !== 'es') url += '#/?locale=' + this.locale
        let url = this.URL.indexOf('http') >= 0 ? this.URL : `https://${this.URL}`
        if (url.indexOf('/#/') > 0 && this.isBC) url += '?bc=true'
        window.location.href = url
      }
    }
  }
</script>
